import styled from '@mui/material/styles/styled'
import Drawer from '@mui/material/Drawer';

export const PrimaryDrawer = styled(Drawer)(({ theme }) => `
    fontFamily: 'Roboto-Medium';
    color: '#FFF';
    & .MuiDrawer-paper{
        background-color:  ${theme.palette.primary.dark}
    }
`)